import history from '../history';
import { AUTH_TOKEN } from '../configs/AppConfig';
import { revokeRefreshToken } from './revokeRefreshToken';
import { MENU_ITEMS, PERMISSION_METRICS, USER } from '../redux/constants/Auth';

export const logout = () => {
  revokeRefreshToken();
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(PERMISSION_METRICS);
  localStorage.removeItem(USER);
  localStorage.removeItem(MENU_ITEMS);
//   ctx.changeToken(null);
//   ctx.changePermission(null);
//   ctx.changeSideMenu(null);
  history.replace('/auth/login');
  window.location.reload(); // force clean app state
};
